// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraSerifDisplayRegular_db02c1', '__fedraSerifDisplayRegular_Fallback_db02c1'"},"className":"__className_db02c1","variable":"__variable_db02c1"};